// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M2 5 L2 4 C2 2.9 2.9 2 4 2 L5 2',
  'M11 2 L12 2 C13.1 2 14 2.9 14 4 L14 5',
  'M14 11 L14 12 C14 13.1 13.1 14 12 14 L11 14',
  'M5 14 L4 14 C2.9 14 2 13.1 2 12 L2 11',
  'M9.25 9.25C9.67 8.83 9.93 8.24 9.93 7.6C9.93 6.31 8.89 5.27 7.6 5.27C6.31 5.27 5.27 6.31 5.27 7.6C5.27 8.89 6.31 9.93 7.6 9.93C8.24 9.93 8.83 9.67 9.25 9.25ZM9.25 9.25L10.13 10.13',
];
